// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"Users_tabsContainer__pmXzA","tab":"Users_tab__3rcbk","tabActive":"Users_tabActive__QTUvj","userCounter":"Users_userCounter__egcUi"};